import { Component, OnInit, Input, ElementRef, Output, EventEmitter, ViewChild, Inject, Optional, HostListener, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { Router} from "@angular/router";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/map";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { RestService } from "../../../../shared/rest.service";
import { ActivitiesService } from "./activitiesMockup.service";
import { BsDatepickerConfig, BsDatepickerDirective } from "ngx-bootstrap";
import { CustomValidator } from "../../../../shared/customValidators";

import { searchPayload } from "../../../../utils/search-functions";
import { UserService } from "../../../../pages/com.usblick.common/auth/user.service";
import { UbicacionesService } from "../../service/ubicaciones.service";

// nuevo
import { MaterialModalConfirmComponent } from "../../../../shared/material-modal-confirm/material-modal-confirm.component";
import { MaterialModalAlertComponent } from "../../../../shared/material-modal-alert/material-modal-alert.component";
import { NotFoundModalComponent } from "../../../../shared/modals/not-found-modal/not-found-modal.component";
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import * as dayjs from "dayjs";
import { of, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { DaterangepickerDirective } from "ngx-daterangepicker-material";
import { setting } from "../../../../../../setting";
import CssFilterConverter from "css-filter-converter";
import { DateRangePickerService } from 'app/shared/date-range-picker/date-range-picker.service';
import { MatAutocomplete } from "@angular/material";
@Component({
  selector: "usb-activities",
  templateUrl: "./activities.component.html",
  styleUrls: ["./activities.component.scss"],
  providers: [UbicacionesService, ActivitiesService],
})
export class ActivitiesComponent implements OnInit, AfterViewInit {
  @Input() form: FormGroup;
  @Input() getClientsSettingAppBooking: any;
  @Input() _close: boolean;
  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() origin = new EventEmitter<any>();
  @Output() modal = new EventEmitter<string>();
  @Input() tabName: string = "";
  @Input() idActivity: number;
  @Input() categoryId: number;

  @ViewChild("dpDeparture") datepickerDeparture: BsDatepickerDirective;
  @ViewChild('iconInfo') iconInfo!: ElementRef;
  @ViewChild("dpArrival") datepickerArrival: BsDatepickerDirective;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('triggerButton') triggerButton: ElementRef;
  @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild('dateRangePicker') dateRangePicker: DaterangepickerDirective;
@ViewChild('auto') auto: MatAutocomplete;
  _findData: boolean;
  _form: FormGroup; // Form Group Activities
  _maxPersons: any; // : [0,1,2,3,4,5];
  minDateDeparture: Date;
  maxDateArrival;
  startDate: any;

  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  isCollapsed = false;
  selectedDestiny: any;
  _longDestination: string;
  destiny: any;
  passengers: string;
  _resultsQuery: any;
  bsConfig: object;
  isLoading_ = false;
  valueQtyChildTour: number = 0;
  qtyPax: number = 1;

  ///  nuevo
  _maxAdults: any;
  _maxChildren: any;
  dateRange: any = { start: null, end: null };
  minDate: dayjs.Dayjs = dayjs().subtract(0, "days");
  maxDate: dayjs.Dayjs = dayjs().add(12, "month");
  destinationOptions: Observable<any[]>;
  destinationOptions_: Observable<any[]>;
  bgClientColor: string;
  isHoverConfirm: boolean;
  agencyId: any;
  componentResults: boolean = false;
  countryCode: string;
  province_name:string;
  isHoveredCancelDate: boolean;
  country_name:string;
  country:string;
  hotel_id:number;
  hotel_name:string;
  endDate: any;
  showModal: boolean = false;
  titleModal: string = 'Advertencia';
  messageModal: string = 'Cree un file en la barra superior para poder iniciar';
  loadingData: boolean = false;
  bsModalRef: BsModalRef;
  initialState: any;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: false,
  };
    private calendarSync: DateRangePickerService;
        routerStorage: any;
        private closing = false;
        private _unsubscribeAll: Subject<any> = new Subject<any>();
        @HostListener('document:click', ['$event'])
        onClickOutside(event: MouseEvent) {
          // Si está cerrado o ya estamos cerrando, salir
          if (!this.isCollapsed || this.closing) {
            return;
          }

          const clickedTrigger = this.triggerButton?.nativeElement.contains(event.target);
          const clickedSelector = this.cardSelectorRoom?.nativeElement.contains(event.target);

          // Si el clic NO fue en el trigger Y NO fue en el selector
          if (!clickedTrigger && !clickedSelector) {
            this.closing = true;
            this._confirm();
          }
        }

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _restService: RestService,
    private ubicacionesService: UbicacionesService,
    private modalService: BsModalService,
    private dialog: MatDialog,
    public userService: UserService,
    public toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ActivitiesComponent>
  ) {

    this._maxPersons = Array.from(Array(26).keys());
    this.dpConfig.containerClass = "theme-red";
    this._maxAdults = Array.from({ length: 10 }, (_, i) => i + 1);
    this._maxChildren = Array.from(Array(11).keys());
    this.minDateDeparture = new Date();
    this.maxDateArrival = new Date();
    this.calendarSync = new DateRangePickerService();
  }

  ngOnInit(): void {
    this.routerStorage = setting.apiStorageBooking;
    this.componentResults = this.data && this.data?.component === "results" ? true : false;
    if(this.componentResults) {
      this.loadingData = true;
    }
    this.clientData();
    this.agencyData();
    this.initForm();

    }

          ngAfterViewInit(): void {
   setTimeout(() => {
        this.setupAutocompleteStyles();
    });

    // this.cdr.detectChanges();
  }


    private setupAutocompleteStyles(): void {
    if (this.auto) {
        this.auto.opened.subscribe(() => {
            setTimeout(() => {
                // Buscar todos los overlays y tomar el último (el más reciente)
                const overlays = document.querySelectorAll('.cdk-overlay-pane');
                const overlay = overlays[overlays.length - 1]; // El último abierto

                if (overlay) {
                    (overlay as HTMLElement).style.minWidth = '30%';
                    (overlay as HTMLElement).style.width = 'fit-content';
                    (overlay as HTMLElement).style.maxWidth = '90vw';
                }
            });
        });
    }

}

  clientData(): void {
        if (this.data && this.data?.clientSetting) {
          this.getClientsSettingAppBooking = this.data?.clientSetting;
          this.idActivity = this.data?.idActivity;
          this.categoryId = this.data?.category;
        }

         this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
  }

  agencyData(): void {
    let agency = JSON.parse(localStorage.getItem("selectedAgency"));
    if(agency) {
      this.agencyId = agency.agency_id;
    }else{
      this.agencyId = this.userService._agencyID;
    }
  }

  initForm(): void {
    this.passengers = "Passengers";
    this._form = this.fb.group({
      destination: [null, Validators.compose([Validators.required, CustomValidator.countryValidator])],
      arrivalDateDepartureDate: ["", Validators.compose([Validators.required, CustomValidator.countryValidator])],
      qtyAdults: [1, [Validators.required, Validators.min(1)]],
      qtyChilds: [0, Validators.required],
      childsage: this.fb.array([]),
    });

    // nuevo
    this.dateRange = "";
    this._form.get("destination").valueChanges.subscribe((selectedValue) => {
      if (selectedValue) {
        this.isLoading_ = true;
        this.destinationOptions = null;
        this.destinationOptions_ = null;
        this.destinationOptions = this.ubicacionesService.getCitys(selectedValue, 'TOURS');
        this.destinationOptions_ = this.ubicacionesService.getAirports(selectedValue);
        this.isLoading_ = false;
      } else {
        this.destinationOptions = this.ubicacionesService.getDestinations("something else");
      }
    });

    if (this.componentResults) {
      this.formPatchValue();
    }
  }

  formPatchValue(): void {

    if(!this.data.payload) {
      this.loadingData = false;
      return;
    }

    if(this.data.idActivity !== this.data.payload[0].categoriesId[0]) {
      this.loadingData = false;
      return;
    }

    const payload = this.data.payload[0];

        if(!payload) {
      this.loadingData = false;
      return;
    }

          // Para arrivalDate
          const [arrivalYear, arrivalMonth, arrivalDay] = payload.arrivalDate.split("-");
          const arrivalDate = new Date(Number(arrivalYear), Number(arrivalMonth) - 1, Number(arrivalDay));

          // Para departureDate (mismo método)
          const [departureYear, departureMonth, departureDay] = payload.departureDate.split("-");
          const departureDate = new Date(Number(departureYear), Number(departureMonth) - 1, Number(departureDay));

          // Asignación al formulario
          this._form.patchValue({
            destination: payload.destination,
            arrivalDateDepartureDate: {
              start: arrivalDate,
              end: departureDate,
            },
            qtyAdults: payload?.others?.tours?.adults ?? 0,
            qtyChilds: payload?.others?.tours?.children.length,
            childsage: payload?.others?.tours?.children,
          });

          // this.setPassanger();
          this.destinationOptions.pipe(take(1)).subscribe((data: any) => {
            if (data && data.length > 0) {
              let destination = data
                .flatMap((element: any) => element.cities || [])
                .find((c: any) => c.city_iata_code === payload.destination && c.city_name === payload.city);

              // Si no se encontró en cities, buscar en airports
              if (!destination) {
                destination = data
                  .flatMap((element: any) => {
                    // Verificar si tiene airports y es un array de objetos
                    if (element.airports && Array.isArray(element.airports) && element.airports.length > 0) {
                      return element.airports;
                    }
                    return [];
                  })
                  .find((a: any) => a.name === payload.destination || a.iata_code === payload.destination);
              }

              if (!destination) {
                destination = data
                  .flatMap((element: any) => {
                    if (element.hotels && Array.isArray(element.hotels) && element.hotels.length > 0) {
                      return element.hotels;
                    }
                    return [];
                  })
                  .find((a: any) => a.name === payload.destination || a.iata === payload.destination);
              }
              if (destination) {
                this.updateMySelection(destination);
                this.loadingData = false;
                // this.updateMyS electionNationality(this.data.form.nationality);
              }
            }
          });

          this._form.patchValue({
            destination: this.data.form.destination,
          });

  }



  formArray(form: FormGroup, key: string) {
    return (<FormArray>form.get(key)).controls;
  }

  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {
    const _payload = [];
    if (this.selectedDestiny !== undefined && this.selectedDestiny !== null) {
      if (event) {
        event.preventDefault();
      }
      const payload = searchPayload(
        "TOURS",
        this.dateRange,
        form,
        this.selectedDestiny,
        "",
        "",
        null,
        "",
        this.agencyId,
        undefined,
        undefined,
        undefined,
        this.idActivity,
        this.categoryId,
        this.countryCode,
        this._longDestination
      );

      payload.providersId = this.userService._providerId;

      localStorage.setItem("form", JSON.stringify(form.value));
      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }

      _payload[0] = payload;
      localStorage.setItem("payload", JSON.stringify(_payload));

      if (this.componentResults) {
        this.dialogRef.close(payload);
        localStorage.setItem("origin", "TOURS");
      } else {

        this._emitLoading(true);
        this._restService.doPost("app", "search", dummy || payload).subscribe(
          (response: any) => {
            if (response !== null && response.results && response.results.length > 0) {
              const payloadArray = [
                searchPayload(
                  "TOURS",
                  this.dateRange,
                  form,
                  this.selectedDestiny,
                  this.agencyId,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  this.idActivity,
                  this.categoryId,
                  this.countryCode,
                  this._longDestination

                ),
              ];
              this.payload.emit(payloadArray);
              //   this._colocarSearchIdEnlosHoteles(response);
              this._setArrivalAndDepartureDate(response, form);
              this._handleResponse(response, "TOURS", form);
              this._emitOrigin("TOURS");
              this._emitLoading(false);
              this._router.navigate(["/results"]);
            } else {
              this._emitLoading(false);
              setTimeout(() => {
                this.initialState = {
                  title: 'No se encontraron resultados',
                  showCancelButton: false,
                  confirmText: 'Cerrar',
                  cancelText: 'Volver a intentar',
                  size: 'sm',
                };
                const modalOptions = Object.assign({}, this.initialState, this.config);
                this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
              }, 3000);

            }
          },
          (error) => {
            const message = "Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo";
            this._emitLoading(false);
            setTimeout(() => {
              const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
                width: "465px",
                data: { message: message },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                  this._onSubmit(form, event);
                } else {
                  this._router.navigate(["/home"]);
                }
              });
            }, 3000);
          }
        );
      }
    } else {
      this._form.get("destination").setErrors({ invalidDestination: true });
    }
  }

  _handleResponse(response: any, categoryName: string, form: FormGroup) {
    if (response && response.results != null) {

      try {
        this._resultsQuery = response.results;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.arrivalDate = form.value["arrivalDate"];
        this._resultsQuery.destination = this._longDestination;

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = "No results found for the search";
        }
        // se anexa el formulario actual
        this._resultsQuery.form = form;
        const arrayResults = [this._resultsQuery];
        this.results.emit(arrayResults);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = "No results found for the search";
      this.results.emit(this._resultsQuery);
    }
  }

  _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  _addChild() {
    this.valueQtyChildTour = this._form.value["qtyChilds"];
    setTimeout(() => {
      const ages: any = this._form.get("childsage") as FormArray;
      const qty: number = +this._form.value["qtyChilds"];
      if (qty > ages.length) {
        for (let i = ages.length; i < qty; i++) {
          ages.push(
            this.fb.group({
              id: [i],
              age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])],
            })
          );
        }
      } else {
        for (let i = ages.length - 1; i >= qty; i--) {
          ages.removeAt(i);
        }
      }
    }, 10);
  }

  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

  /// nuevo

  _setArrivalAndDepartureDate(response: any, form) {
    response.results.forEach((obj) => {
      obj.dateIni = moment(this.dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD");
      obj.dateEnd = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD");
    });
  }

  startDateClicked($event) {
    this.endDate = null;
    this.startDate = $event;
    this.onDateRangeChange();
    //  this.maxDate = moment($event.startDate._d).add(1, 'month');
  }

  onDateRangeChange(): void {
    // Ver si dateRange tiene startDate y endDate
    if (this.startDate && !this.endDate) {
        // Si tiene startDate y NO tiene endDate (aún no completó el rango)
            this.calendarSync.setStartDate(this.startDate ? this.startDate : this.dateRange.start);
        }
        // Si tiene startDate y endDate (rango completo)
    if (this.startDate && this.endDate) {
            this.calendarSync.clearStartDate();
        }
    }


  endDateClicked($event: any): void {
    // Convertimos a Day.js las fechas para garantizar consistencia
    const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf("day");
    const selectedEndDate = dayjs($event.endDate.$d).startOf("day"); // Normaliza al inicio del día
    this.endDate = $event;

    // Validar si la fecha de fin es inválida, igual o anterior a la fecha de inicio
    // if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {
    //   this.toastr.warning("Debe elegir mínimo un día de diferencia con el día de inicio");

    //   this._form.get("arrivalDateDepartureDate")?.setValue(null); // Limpia el campo en el formulario

    //   setTimeout(() => {
    //     this.picker.clear(); // Limpia cualquier selección previa del datePicker
    //     this.picker.open(); // Reabre el calendario para seleccionar una nueva fecha
    //     // Resetea el rango de fechas y el formulario
    //   }, 100);
    // } else {
      this.dateRange = { start: selectedStartDate, end: selectedEndDate };
    // }
  }

  /***********************************************Auto Complete********************************************/

capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}

  observableSource = (keyword: any): Observable<any[]> => {
    return this.ubicacionesService.getCitys(keyword);
  };

  displayFn(name: any) {
    if (name) {
      if (name.city_name != undefined) {
        return name.city_name;
      }
      if (name.name_airport != undefined) {
        return name.name_airport;
      }
    }
  }
  updateMySelection(event: any) {
    if (event) {
      this.destiny = event.city_name ? event.city_name : "";
      this.selectedDestiny = event.city_iata_code ? event.city_iata_code : "";
      this._longDestination = event.city_name ? event.city_name : "";
      this.countryCode = event.country_iata_code ? event.country_iata_code : "";
      this.country = event.country_iata_code ? event.country_iata_code : "";
      this.country_name = event.country_name ? event.country_name : "";
      this.province_name = `${event.city_province ? ', ' : ''}${event.city_province ? event.city_province : ''}`;
      /// this.destiny['cityName'] =  event.cityName;
      this.selectedDestiny = event.city_iata_code ? event.city_iata_code : "";
      if(!this.country) {
        this.countryCode = event.country_code ? event.country_code : "";
         this.selectedDestiny = event.iata ? event.iata : "";
        this.hotel_id = event.id ? event.id : "";
        this.hotel_name = event.name ? event.name : "";
        this.country = event.country_code ? event.country_code : "";

      }
    }
  }
  /***********************************************Auto Complete********************************************/
  _over() {
    this.modal.emit("false");
  }

  clickOutside(event: any) {
    this.setPassanger();
  }

  _openModal() {
    this.applyImageFilter();
    this.isCollapsed = true;
    this._close = false;
      this.closing = false;
    setTimeout(() => {
      this.modal.emit("true");
    }, 100);
  }

  _confirm() {
    this.isCollapsed = false;
    this.setPassanger();

        setTimeout(() => {
    this.closing = false;
  }, 100);
  }

  setPassanger() {
    let adults = this._form.value["qtyAdults"];
    let childs = this._form.value["qtyChilds"];
    let noSelected = parseInt(adults) === 0 && parseInt(childs) === 0;
    adults = adults != undefined ? adults + " Adultos " : null;
    childs = childs != undefined ? " - " + childs + " Niños " : null;

    this.passengers = noSelected ? "Passengers" : adults + childs;
  }

  setOptions(tipo: String): void {
    if (tipo != "departure") {
      this.bsConfig = Object.assign({}, { maxDate: this.maxDateArrival });
      this.datepickerArrival.setConfig();
      return;
    }

    this.bsConfig = Object.assign({}, { minDate: this.minDateDeparture });
    //this.datepickerDeparture.setConfig();
  }

  updateButtonColorConfirm() {
    const button = document.querySelector(".btn-choice-confirm") as HTMLElement;
    if (this.isHoverConfirm) {
      button.style.backgroundColor = this.bgClientColor;
    } else {
      button.style.backgroundColor = "white";
    }
  }

  close(): void {
    this.dialogRef.close(null);
  }


  fileActive():void {
      this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  confirmAction() {
    this.closeModal();
  }

    resetDestiny(): void {
    this._form.get('destination').setValue(null);
    this.destiny = undefined;
    this.selectedDestiny = undefined;
    this._longDestination = undefined;
    this.selectedDestiny =  undefined;
    // this.country = undefined;
    this.province_name = undefined;
  }


/**
 * Abre y posiciona estratégicamente el date picker en relación al input de búsqueda
 *
 * Este método abre el date picker y realiza ajustes de posicionamiento avanzados para
 * asegurar que se muestre correctamente en la pantalla, evitando que se corte o salga
 * del viewport. Específicamente diseñado para el componente de resultados.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Requiere que `this.picker` esté inicializado
 * - Solo ejecuta si `this.componentResults` es true
 *
 * @process
 * 1. Abre el date picker mediante `this.picker.open()`
 * 2. Espera con setTimeout para asegurar renderizado del DOM
 * 3. Calcula posición basada en el input de búsqueda
 * 4. Aplica estilos de posicionamiento fixed preciso
 * 5. Realiza ajustes finales con `adjustElementPosition`
 *
 * @positioning
 * - Posición: fixed (respecto al viewport)
 * - Top: bottom del input + scroll vertical
 * - Left: left del input + scroll horizontal
 * - Z-index: 9999 (máxima prioridad visual)
 *
 * @styling
 * - transform: 'none' (anima transformaciones CSS)
 * - maxHeight: 'none' (permite expansión completa)
 * - overflow: 'visible' (evita scroll interno)
 *
 * @uses adjustElementPosition() - Para ajustes de boundaries del viewport
 */
openDatePicker() {
  if (this.picker && this.componentResults) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;
      const inputElement = document.querySelector('.input-search-box') as HTMLElement;

      if (pickerElement && inputElement) {
        // Calculamos la posición del input en el viewport
        const inputRect = inputElement.getBoundingClientRect();

        // Ajustamos la posición del picker relativa al input
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        pickerElement.style.left = `${inputRect.left + window.scrollX}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.maxHeight = 'none';
        pickerElement.style.overflow = 'visible';
        pickerElement.style.zIndex = '9999';

        // Verificamos si el picker se sale de la pantalla y ajustamos
        this.adjustElementPosition(pickerElement, inputRect);
      }
    });
  }

        const mdPicker = document.querySelector('.md-drppicker');
        if (mdPicker) {
          this.calendarSync.setup(mdPicker as HTMLElement);
        }
}

/**
 * Ajusta la posición de un elemento para asegurar que permanezca dentro de los límites del viewport
 *
 * Este método calcula si un elemento (picker o contenedor) se sale de los límites visibles
 * de la pantalla y realiza ajustes automáticos de posición para mantenerlo completamente visible.
 *
 * @param {HTMLElement} pickerElement - Elemento HTML cuya posición necesita ser ajustada
 * @param {DOMRect} inputRect - Rectángulo del elemento de referencia para cálculos de posición
 * @returns {void}
 *
 * @calculations
 * - pickerRect: Obtiene dimensiones y posición actual del elemento mediante getBoundingClientRect()
 * - viewportHeight: Altura visible del viewport (window.innerHeight)
 * - viewportWidth: Ancho visible del viewport (window.innerWidth)
 *
 * @adjustments
 * 1. **Ajuste Vertical**: Si el elemento se sale por la parte inferior del viewport,
 *    lo reposiciona arriba del elemento de referencia
 * 2. **Ajuste Horizontal**: Si el elemento se sale por el lado derecho del viewport,
 *    lo alinea con el margen izquierdo del viewport con un padding de 10px
 *
 * @formulaVertical
 * - Nueva posición: inputRect.top + window.scrollY - pickerRect.height
 * - Explicación: Posición superior del input menos altura del picker
 *
 * @formulaHorizontal
 * - Nueva posición: viewportWidth - pickerRect.width - 10
 * - Explicación: Ancho del viewport menos ancho del picker con margen de 10px
 *
 * @usage
 * Utilizado por openDatePicker() y expandedConfigPassenger() para mantener elementos
 * flotantes dentro del área visible
 */
adjustElementPosition(pickerElement: HTMLElement, inputRect: DOMRect) {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Ajuste vertical (si no cabe abajo, mostramos arriba)
  if (pickerRect.bottom > viewportHeight) {
    pickerElement.style.top = `${inputRect.top + window.scrollY - pickerRect.height}px`;
  }

  // Ajuste horizontal (si no cabe a la derecha, alineamos a la izquierda)
  if (pickerRect.right > viewportWidth) {
    pickerElement.style.left = `${viewportWidth - pickerRect.width - 10}px`;
  }
}

incrementPassenger(): void {
  this.qtyPax++;
}

decrementPassenger(): void {
  this.qtyPax--;
}


getPassenger(): number {
  return this.qtyPax;
}

  /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}



incrementPassengerAdult(event?: Event) {

      if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('qtyAdults')?.value || 0;

    // Validar máximo
    if (currentValue >= 10) return;

    // Actualizar usando patchValue (método reactivo)
    form.patchValue({
        qtyAdults: currentValue + 1
    });
}

decrementPassengerAdult(event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('qtyAdults')?.value || 0;

    // Validar mínimo (mínimo 1 adulto)
    if (currentValue <= 1) return;

    // Actualizar usando patchValue
    form.patchValue({
        qtyAdults: currentValue - 1
    });
}

incrementPassengerChildren(item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('qtyChilds')?.value || 0;

    // Validar máximo
    if (currentValue >= 10) return;

    // Actualizar usando patchValue
    form.patchValue({
        qtyChilds: currentValue + 1
    });

    // Añadir control de edad para el nuevo niño
    const ages = form.get("childsage") as FormArray;
    ages.push(this.fb.group({
        id: [currentValue],
        age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
    }));
}

decrementPassengerChildren(item: FormGroup, event?: Event) {

    if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }

    const form = this._form;

    // Obtener valor actual
    const currentValue = form.get('qtyChilds')?.value || 0;

    // Validar mínimo
    if (currentValue <= 0) return;

    // Actualizar usando patchValue
    form.patchValue({
        qtyChilds: currentValue - 1
    });

    // Eliminar control de edad del último niño
    const ages = form.get("childsage") as FormArray;
    if (ages.length > 0) {
        ages.removeAt(ages.length - 1);
    }
}

getPassengerCountAdult(): number {

    return this._form.get('qtyAdults')?.value || 0;
}

getPassengerCountChildren(): number {
    return this._form.get('qtyChilds')?.value || 0;
}

  validatePassengerInput(event: any) {

        if (event) {
          event.stopPropagation(); // Evita que el clic se propague
          event.preventDefault();  // Previene comportamiento por defecto
      }

      const inputValue = parseInt(event.target.value, 10);
      const form = this._form;

      // Determinar si es adulto o niño (podrías pasar un parámetro)
      const isAdult = event.target.name === 'adults'; // Asigna nombres a los inputs

      if (isAdult) {
          // Validar adultos (1-10)
          const validatedValue = Math.max(1, Math.min(10, isNaN(inputValue) ? 1 : inputValue));
          form.patchValue({ qtyAdults: validatedValue });
      } else {
          // Validar niños (0-10)
          const validatedValue = Math.max(0, Math.min(10, isNaN(inputValue) ? 0 : inputValue));
          form.patchValue({ qtyChilds: validatedValue });

          // Ajustar array de edades
          this.adjustChildrenAges(validatedValue);
      }
  }

private adjustChildrenAges( newChildCount: number): void {
    const form = this._form;
    const ages = form.get("childsage") as FormArray;
    const currentCount = ages.length;

    if (newChildCount > currentCount) {
        // Agregar edades faltantes
        for (let i = currentCount; i < newChildCount; i++) {
            ages.push(this.fb.group({
                id: [i],
                age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
            }));
        }
    } else if (newChildCount < currentCount) {
        // Eliminar edades excedentes
        while (ages.length > newChildCount) {
            ages.removeAt(ages.length - 1);
        }
    }
}

// Agrega estos métodos a tu componente

handleAdultInput(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    // Prevenir entrada de 0 como primer dígito
    if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }
}
    // qtyAdults: [1, [Validators.required, Validators.min(1)]],
    // qtyChilds: [0, Validators.required],
    // childsage: this.fb.array([]),
handleAdultBlur(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();
    const form = this._form;

    if (value === '' || value === '0' || isNaN(parseInt(value, 10))) {
        form.patchValue({ qtyAdults: 1 });
        event.target.value = '1';
    }

    if(value !== '' && parseInt(value, 10) > 10) {
      const numericValue = parseInt(value, 10);
      event.target.value = numericValue.toString();

      form.patchValue({ qtyAdults: 1 });
      event.target.value = '10';
    }

}


handleChildrenInput(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const currentValue = event.target.value;

    // Si está vacío y se presiona 0, prevenir
    if (event.key === '0' && currentValue === '') {
        event.preventDefault();
        return;
    }

    // Solo permitir números
    if (!/^\d$/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        return;
    }

    // Prevenir que escriba más de 2 dígitos (para edades hasta 17)
    if (/^\d$/.test(event.key) && currentValue.length >= 2) {
        event.preventDefault();
        return;
    }
}

handleChildrenBlur(event: any): void {

        if (event) {
        event.stopPropagation(); // Evita que el clic se propague
        event.preventDefault();  // Previene comportamiento por defecto
    }
    const value = event.target.value.trim();

    // Si está vacío, poner 0
    if (value === '' || isNaN(parseInt(value, 10))) {
        const form = this._form;
        form.patchValue({ qtyAdults: 0 });
        event.target.value = '0';
        this.adjustChildrenAges(0);
    } else {
        // Si tiene un valor válido, asegurarse de que no tenga ceros a la izquierda
        const numericValue = parseInt(value, 10);
        event.target.value = numericValue.toString();

         const form = this._form;
        form.patchValue({ qtyAdults: numericValue });
        this.adjustChildrenAges(numericValue);
    }
}

preventModalClose(event: MouseEvent): void {
    // Detiene la propagación del evento click para que no llegue al listener
    // que cierra el modal
    event.stopPropagation();
    event.preventDefault();

    // Opcional: Forzar el foco en el input
    const target = event.target as HTMLInputElement;
    target.focus();
}

agesChildsArr(): string[] {
    return Array.from({length: 19}, (_, index) => {
        return index.toString();
    });
}


/**
 * Expande y posiciona estratégicamente el contenedor de configuración de pasajeros
 *
 * Este método ajusta el posicionamiento del contenedor de configuración de pasajeros
 * para que aparezca fijo en relación al elemento contenedor, con ajustes automáticos
 * para evitar que se salga de los límites del viewport.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Solo ejecuta si `this.componentResults` es true
 * - Requiere que existan los elementos DOM correspondientes
 *
 * @process
 * 1. Localiza elementos DOM del contenedor y configuración
 * 2. Calcula posición basada en el contenedor padre
 * 3. Aplica estilos de posicionamiento fixed preciso
 * 4. Realiza ajustes de boundaries con `adjustElementPosition`
 *
 * @positioning
 * - Posición: fixed (respecto al viewport)
 * - Top: bottom del contenedor + scroll vertical
 * - Left: left del contenedor + scroll horizontal
 * - Z-index: 9999 (máxima prioridad visual)
 *
 * @elements
 * - .config-passenger: Elemento a posicionar
 * - .element-config-passenger: Elemento de referencia para posicionamiento
 *
 * @uses adjustElementPosition() - Para ajustes de boundaries del viewport
 */
expandedConfigPassenger(): void {

  if(this.componentResults) {
    const configPassengerElement = document.querySelector('.config-passenger') as HTMLElement;
    const configPassengerContainer = document.querySelector('.element-config-passenger') as HTMLElement;
    console.log(configPassengerContainer)
    console.log(configPassengerElement)
    if(configPassengerElement && configPassengerContainer) {

      // Calculamos la posición del input en el viewport
        const inputRect = configPassengerContainer.getBoundingClientRect();

       // Ajustamos la posición del picker relativa al input
        configPassengerElement.style.position = 'fixed';


        // configPassengerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        // configPassengerElement.style.left = `${inputRect.left + window.scrollX}px`;
        configPassengerElement.style.transform = 'none';
        configPassengerElement.style.maxHeight = 'none';
        configPassengerElement.style.overflow = 'visible';
        configPassengerElement.style.zIndex = '9999';

        configPassengerContainer.getBoundingClientRect();

          // Verificamos si el picker se sale de la pantalla y ajustamos
        // this.adjustElementPosition(configPassengerElement, inputRect);
    }

  }

}

  // ============================================
  // MÉTODOS DE PERSONALIZACIÓN DE UI
  // ============================================

  /**
   * Aplica filtro de color a los iconos basado en configuración del cliente
   * Convierte el color principal del cliente a filtro CSS
   */
  applyImageFilter() {
    const color = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;

    if (!color) {
      console.warn('No color defined');
      return;
    }

    try {
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";
      const filter = colorFilter;

      this.iconInfo.nativeElement.style.filter = filter;


    } catch (error) {
      console.error('Error applying image filter:', error);
    }
  }



}
